export var IntegrationQueueType;
(function (IntegrationQueueType) {
    IntegrationQueueType["Sqs"] = "sqs";
    IntegrationQueueType["Kinesis"] = "kinesis";
    IntegrationQueueType["SqsDLQ"] = "sqs-dlq";
    IntegrationQueueType["Sns"] = "sns";
})(IntegrationQueueType || (IntegrationQueueType = {}));
export var IntegrationEventType;
(function (IntegrationEventType) {
    IntegrationEventType["Element"] = "element";
    IntegrationEventType["Calculation"] = "calculation";
    IntegrationEventType["LockingCalc"] = "locking_calc";
    IntegrationEventType["ChangeRequest"] = "changeRequest";
    IntegrationEventType["NodeValidation"] = "node_validation";
})(IntegrationEventType || (IntegrationEventType = {}));
//# sourceMappingURL=integrationEventQueueEnums.js.map